module.exports = __webpack_public_path__ + "static/media/cook-islands.7c22a5cf.png";